function string2number(s){
  // convertit une chaine de caractère contenant un mois en nombre
  // Ex: "Mars" -> 3
  const months = {
    "January": 1,
    "February": 2,
    "March": 3,
    "April": 4,
    "May": 5,
    "June": 6,
    "July": 7,
    "August": 8,
    "September": 9,
    "October": 10,
    "November": 11,
    "December": 12,
  };
  return months[s] ?? 0;
}




export default {
  name: "Amaury CURIEL",
  tagline: "PhD Student in Computer Science",
  description:
    "I work on the generation and study of directed acyclic graphs as well as on the lexicographic generation of simpler combinatorial objects.",
  buttons: {
    contact: "Contact Me",
    cv: "View CV",
    prenom: "First Name",
    nom: "Last Name",
  },
  project : "Member of the project [pandag:ANR PAnDAG]",
  links: {
    pandag : "https://pandag.proj.lip6.fr",
  },
  sections: {
    interests: {
      title: "Interests",
      items: [
        "Directed Acyclic Graphs (DAGs)",
        "BDDs",
        "Random Generation",
        "Unranking Algorithms",
        "Set Partitions",
      ],
    },
    education: {
      title: "Education",
      items: [
        "PhD Student (Sorbonne University, LIP6, APR)",
        "Master's in Computer Science (Sorbonne University, STL)",
        "Double Bachelor's in Mathematics and Computer Science (University of Paris-Saclay)",
      ],
    },
  },
  homepage: {
    title: "Home",
  },
  research: {
    title: "Research",
    description:
      "Currently in my second year of PhD within the APR team at LIP6 under the supervision of [sorbonne:Antoine Genitrini], my thesis " +
      "focuses on the study of directed acyclic graphs (DAGs). I am particularly interested in BDDs, a class of DAGs resulting from the compression of boolean functions. My " +
      "goal is to study their distributions as well as to generate them as efficiently as possible while constraining certain parameters." +
      " Another class I study is that of directed acyclic ordered graphs (DOAGs). For this structure, I seek to determine their asymptotic behavior as well as to study the proportion of certain parameters." +
      " Finally, I am also interested in the generation by lexicographic unranking of simpler combinatorial objects such as set partitions or integers.",
    links: {
      sorbonne: "https://www.sorbonne-universite.fr",
    },
  },
   preprints:{
    title: "Preprints",
    bib_copy: "Copy",
bib_copied: "Copied",
bib_close: "Close",
list: [
      {
        title: "Lexicographic Unranking Algorithms for the Twentyfold Way",
        authors: "Co-written with Antoine Genitrini",
        description: "Preprint", 
        pdfUrl: "https://hal.science/hal-05486059v1",
        date : "February 2026", 
        bibtex: `@unpublished{curiel:hal-05486059,
  TITLE = {{Lexicographic unranking algorithms for the Twentyfold Way}},
  AUTHOR = {Curiel, Amaury and Genitrini, Antoine},
  URL = {https://hal.science/hal-05486059},
  NOTE = {working paper or preprint},
  YEAR = {2026},
  KEYWORDS = {Twentyfold Way ; Twelvefold Way ; Unranking ; Combinatorial generation ; Lexicographic order ; Thirtyfold Way},
  PDF = {https://hal.science/hal-05486059v1/file/CurielGenitrini_vHAL.pdf},
  HAL_ID = {hal-05486059},
  HAL_VERSION = {v1},
}`
      },]
  },
  featuredPublications: {
    title: "Publications (Conferences and Journals)",
    bib_copy: "Copy",
    bib_copied: "Copied",
    bib_close: "Close",
    list: [
      {
        title: "Lexicographic Unranking Algorithms for the Twelvefold Way",
        authors: "With Antoine Genitrini",
        description: "Published in the proceedings of [aofa: AofA 2024]",
        pdfUrl:
          "https://drops.dagstuhl.de/entities/document/10.4230/LIPIcs.AofA.2024.17",
        videoUrl: "https://www.youtube.com/watch?v=g6HHldZHgp0",
        diapourl: "assets/pres_AofA.pdf",
        date: "June 2024",
        links: {
          aofa: "https://www.math.aau.at/AofA/",
        },
        bibtex: `@InProceedings{curiel_et_al:LIPIcs.AofA.2024.17,
  author =	{Curiel, Amaury and Genitrini, Antoine},
  title =	{{Lexicographic Unranking Algorithms for the Twelvefold Way}},
  booktitle =	{35th International Conference on Probabilistic, Combinatorial and Asymptotic Methods for the Analysis of Algorithms (AofA 2024)},
  pages =	{17:1--17:14},
  series =	{Leibniz International Proceedings in Informatics (LIPIcs)},
  ISBN =	{978-3-95977-329-4},
  ISSN =	{1868-8969},
  year =	{2024},
  volume =	{302},
  editor =	{Mailler, C\'{e}cile and Wild, Sebastian},
  publisher =	{Schloss Dagstuhl -- Leibniz-Zentrum f{\"u}r Informatik},
  address =	{Dagstuhl, Germany},
  URL =		{https://drops.dagstuhl.de/entities/document/10.4230/LIPIcs.AofA.2024.17},
  URN =		{urn:nbn:de:0030-drops-204522},
  doi =		{10.4230/LIPIcs.AofA.2024.17},
  annote =	{Keywords: Twelvefold Way, Set partitions, Unranking, Lexicographic order}
}
        `,
      },
    ],
  },
  experiencePage: {
    title: "Curriculum Vitae",
        rexp : {
      title: "Research Experiences",
      timeline: [
            {
          institution: "Sorbonne University, LIP6",
          role: "PhD Student in Computer Science",
          location: "Paris, France",
          date: "2024 – Present",
          description: "Thesis: Combinatorics of Binary Decision Diagrams (BDD)",
          type: "work",
        },
        {
          institution: "LIP6",
          role: "Research Internship (6 months)",
          location: "Paris, France",
          date: "July–August 2024",
          description: "Enumeration and unranking of ZDDs by profile.",
          type: "work",
        },
        {
          institution: "LIP6",
          role: "Voluntary Research Internship (2 months)",
          location: "Paris, France",
          date: "June–July 2023",
          description:
            "Generation of set partitions through lexicographic unranking.",
          type: "work",
        }

      ]
    },
    parcours: {
      title: "Academic Background",
      timeline: [
     
        {
          institution: "Sorbonne University",
          role: "Master’s in Computer Science, Software Science and Technology track",
          location: "Paris, France",
          date: "2022–2024 — with honors",
          description:
            "Master’s degree specialized in algorithms, programming, and software engineering.",
          type: "education",
        },
  
        {
          institution: "Université Paris-Saclay",
          role: "Double Bachelor’s in Mathematics and Computer Science",
          location: "Orsay, France",
          date: "2019 – 2022",
          description: "Training in mathematics and computer science.",
          type: "education",
        },
      ],
    },
    skills: {
      programming: {
        title: "Programming Paradigms",
        list: [
          {
            name: "Concurrent",
            language: [
              {
                name: "Go",
                logo: "assets/go_logo.png",
              },
            ],
          },
          {
            name: "Functional",
            language: [
              {
                name: "OCaml",
                logo: "assets/ocaml_logo2.png",
              },
              {
                name: "Haskell",
                logo: "assets/haskell_logo.png",
              },
            ],
          },
          {
            name: "Object-Oriented",
            language: [
              {
                name: "Java",
                logo: "assets/java_logo.png",
              },
              {
                name: "C++",
                logo: "assets/cpp_logo.png",
              },
              {
                name: "Python",
                logo: "assets/python_logo.png",
              },
            ],
          },
          {
            name: "Imperative",
            language: [
              {
                name: "C",
                logo: "assets/c_logo.png",
              },
            ],
          },
          {
            name: "Proof Assistants",
            language: [
              {
                name: "Coq/Rocq",
                logo: "assets/coq_logo.png",
              },
              {
                name: "Lean4",
                logo: "assets/lean_logo.svg",
              },
            ],
          },
        ],
      },
      competences: {
        title: "Skills",
        list: [
          {
            title: "Algorithms",
            list: [
              {
                name: "Design",
              },
              {
                name: "Implementation",
              },
              {
                name: "Analysis",
              },
              {
                name: "Practical performance testing",
              },
            ],
          },
          {
            title: "Mathematics",
            list: [
              {
                name: "Analysis",
              },
              {
                name: "Probability",
              },
              {
                name: "Analytic Combinatorics",
              },
            ],
          },
          {
            title: "Software Development",
            list: [
              {
                name: "CI/CD",
              },
              {
                name: "Testing",
              },
              {
                name: "Architecture",
              },
            ],
          },
          {
            title: "Program analysis",
            list: [
              {
                name: "Compilation",
              },
              {
                name: "Model checking",
              },
              {
                name: "Abstract interpretation",
              },
            ],
          },
        ],
      },
      languages: {
        title: "Languages",
        list: [
          {
            name: "French",
            level: "Native language",
            flag: "assets/fr_flag.png",
          },
          {
            name: "Spanish",
            level: "Fluent",
            flag: "assets/es_flag.png",
          },
          {
            name: "English",
            level: "Fluent",
            flag: "assets/en_flag.png",
          },
          {
            name: "Mandarin Chinese",
            level: "HSK 2, HSK 3 in progress",
            flag: "assets/zh_flag.png",
          },
          {
            name: "Russian",
            level: "A1",
            flag: "assets/ru_flag.png",
          },
        ],
      },
    },
  },
  teaching: {
    title: "Teaching",
    ues: [
      {
        title: "Algorithm analysis and random generation",
        level: "Master 2",
        participation: "Courses, Tutorial sessions & practical work",
        year: "2024",
        description:
          "Random generation of numbers, simple structures, and graphs.",
        ressources: [
          {
            title: "Slides",
            url: "assets/diapos_aaga.pdf",
          },
          {
            title: "Test",
            url: "assets/pres_AofA.pdf",
          },
        ],
      },
          {
        title: "Discrete Mathematics",
        level: "Bachelor 2",
        participation: "Tutorial sessions & practical work",
        year: "2025",
        description: "The aim of this course is to present the mathematical tools that are the basis of the techniques used in most areas of computer science. In particular, several of the concepts covered are related to program termination problems, recursion and compilation, the other theme addressed being that of logic.",
      },
      {
        title: "Advanced Algorithms",
        level: "Master 1",
        participation: "Tutorial sessions",
        year: "2025",
        description:
          "The aim of this course is to show how the use of advanced data structures can optimize the performance of algorithms in various application areas such as the management and compression of massive data.",
      },
      {
        title: "Discrete Mathematics",
        level: "Bachelor 2",
        participation: "practical work",
        year: "2024",
        description: "Implementation of an automata library in Python",
      },
      {
        title: "Advanced Data Structures",
        level: "Bachelor 2",
        participation: "Tutorial sessions & practical work",
        year: "2025",
        description:
          "Programming of data structures (lists, hash tables, trees, and graphs) in C & design of algorithms on these structures.",
      },
      {
        title: "Engineering project",
        level: "Master 1",
        participation: "Supervisor",
        year: "2025",
        description:
          "Supervision of a group of 2 students. Design, state of the art, and implementation of lexicographic generation algorithms by unranking for each of the 12 Rota problems.",
        ressources: [
          {
            title: "Subject",
            url: "assets/sujet.pdf",
          },
        ],
      },
      {
        title:
          "Outreach: Introduction to Programming – Recreating the Game Space Invaders",
        level:
          "Hosting 9th grade students as part of their mandatory internship",
        participation: "Conception and animation of the activity",
        description:
          "Introduction to programming concepts through the recreation of the game Space Invaders.",
        year: "2025",
        month: "March",
        ressources: [
          {
            title: "Assignment",
            url: "assets/activite.pdf",
          },
        ],
      },
    ].sort((a, b) => {
  if (a.year === b.year) {
    return (Number(b.month ?? 0)) - (Number(a.month ?? 0));
  } else {
    return b.year - a.year;
  }
}),
  },
  expose: {
    title: "Talks",
    list: [
      {
        title:
          "Lexicographic Unranking Algorithms for the Twenty Problems of Bogart",
        event: "APR Team Days",
        date: "June 2025",
        ressources: [
          {
            title: "Slides",
            url: "assets/pres_apr2.pdf",
          },
        ],
      },
      {
        title: "Enumeration of BDDs by profile",
        event: "Workshop Pandag",
        date: "May 2025",
        ressources: [
          {
            title: "Slides",
            url: "assets/pres.pdf",
          },
          {
            title: "Abstract",
            url: "assets/abstract_en.pdf",
          },
        ],
      },
      {
        title: "Unranking of ZDDs",
        event: "APR Team Days",
        date: "June 2024",
        ressources: [
          {
            title: "Slides",
            url: "assets/pres_apr.pdf",
          },
          {
            title: "Abstract",
            url: "assets/abstract_apr.pdf",
          },
        ],
      },
      {
        title: "Lexicographic Unranking Algorithms for the Twelvefold Way",
        event: "AofA 2024",
        date: "June 2024",
        ressources: [
          {
            title: "Slides",
            url: "assets/pres_AofA.pdf",
          },
          {
            title: "Article",
            url: "https://drops.dagstuhl.de/entities/document/10.4230/LIPIcs.AofA.2024.17",
          },
          {
            title: "Video",
            url: "https://www.youtube.com/watch?v=g6HHldZHgp0",
          },
        ],
      },
    ],
  },
  software: {
    title: "Softwares",
    list: [
      {
        name: "setpartition_unrank",
        language: "Go",
        logo: "assets/go_logo.png",
        description:
          "Library for generating set partitions through lexicographic unranking. This implementation uses Go's concurrent paradigm to be memory-efficient without sacrificing execution time.",
        url: "https://github.com/AMAURYCU/setpartition_unrank.git",
      },
      {
        name: "ZDD Generator",
        language: "Go",
        logo: "assets/go_logo.png",
        description:
          "Library for generating ZDDs of a given profile through unranking. The profile can also be generated by unranking. This library also allows for the generation of ROBDDs by first generating a ZDD and then applying a bijective transformation.",
      },
      {
        name: "Rota engine",
        language: "Python",
        logo: "assets/python_logo.png",
        description:
          "Collection of Python files for generating objects described by Kenneth P. Bogart in his Twentyfold ways through unranking (combinatorial or lexicographic order).",
        url: "https://github.com/AMAURYCU/Unranking_of_partitions"
      },
    ],
    default: "Coming soon",
    visit: "Learn more"
  },
};
